module.exports = __webpack_public_path__ + "static/img/upgrade-marley-MEnV180.185aefd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/offer/upgrade-marley-MEnV180.jpg
// module id = 54
// module chunks = 1 2